import { Controller } from "@hotwired/stimulus"

// 配信数一覧のビル行で、配下の空室行をまとめて開閉する。
//
// 既存の accordion_controller はパネルを1つの要素で包む前提のため、
// テーブルの兄弟 tr 群には使えない。ビルごとに tbody を分け、
// その tbody をコントローラの範囲にすることで、子行をターゲットにできる。
export default class extends Controller<HTMLElement> {
  static targets = ["child", "icon"]

  declare readonly childTargets: HTMLElement[]
  declare readonly iconTarget: HTMLElement

  toggle(event: Event) {
    const trigger = event.currentTarget as HTMLElement
    const expanded = trigger.getAttribute("aria-expanded") !== "false"

    this.childTargets.forEach((child) => child.classList.toggle("hidden", expanded))
    this.iconTarget.classList.toggle("-rotate-90", expanded)
    trigger.setAttribute("aria-expanded", (!expanded).toString())
  }
}
